import LogoutPopupComponent from './LogoutPopupComponent';

export default LogoutPopupComponent;
